module.exports = __webpack_public_path__ + "media/images/Label-d903dc26efd382b1b0d51cfa3ed3663d.svg";